import { FC } from 'react'
import Styles from './Header.module.scss'

const Header: FC<React.PropsWithChildren<unknown>> = ({ children }) => <div className={Styles.header}>{children}</div>

export { Header }
